import React from 'react';
import { Box, formilyReact, CnAsyncSelect } from '@alife/cn-ui';
import { RequestParamsMap } from "../const";
var Field = formilyReact.Field,
  observer = formilyReact.observer;
var paramsTypeDataSource = Object.keys(RequestParamsMap).map(function (key) {
  var _RequestParamsMap$key;
  return {
    label: (_RequestParamsMap$key = RequestParamsMap[key]) === null || _RequestParamsMap$key === void 0 ? void 0 : _RequestParamsMap$key.name,
    value: key
  };
});
var ParamsSelectSetter = observer(function (props) {
  return /*#__PURE__*/React.createElement(Box, {
    direction: 'row'
  }, /*#__PURE__*/React.createElement(Field, {
    name: 'paramType',
    component: [CnAsyncSelect, {
      style: {
        width: '35%'
      },
      placeholder: '请选择参数类型',
      dataSource: paramsTypeDataSource
    }]
  }), /*#__PURE__*/React.createElement(Field, {
    name: 'content',
    component: [CnAsyncSelect.AutoComplete, {
      style: {
        width: '65%'
      }
    }]
  }));
});
export default ParamsSelectSetter;